import { HTMLAttributes } from 'react'

import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import Section from '@/components/base/Section'
import Typography from '@/components/base/Typography'

import { cn } from '@/lib/utils'

export type SingleParagraphProps = HTMLAttributes<HTMLElement> &
  Partial<{
    overline: string
    align: 'left' | 'center' | 'right'
    title: string
    paragraph: string
  }>

const SingleParagraph = ({
  title,
  align,
  paragraph,
  ...props
}: SingleParagraphProps) => {
  return (
    <Section {...props}>
      <Container>
        <Grid className="gap-y-[2.5rem]">
          {title ? (
            <div
              className={cn({
                'col-span-4 md:col-span-6 lg:col-span-3 lg:col-start-3':
                  align === 'left',
                'col-span-4 text-center md:col-span-6 lg:col-span-8 lg:col-start-3':
                  align === 'center',
                'col-span-4 md:col-span-4 md:col-start-2 lg:col-span-6 lg:col-start-6':
                  align === 'right'
              })}
            >
              <Typography
                variant="h1"
                className="uppercase"
                component="h2"
                data-motion-title
              >
                {title}
              </Typography>
            </div>
          ) : null}

          {paragraph ? (
            <div
              className={cn({
                'col-span-4 md:col-span-6 lg:col-span-3 lg:col-start-3':
                  align === 'left',
                'col-span-4 text-center md:col-span-6 lg:col-span-8 lg:col-start-3':
                  align === 'center',
                'col-span-4 md:col-span-4 md:col-start-2 lg:col-span-6 lg:col-start-6':
                  align === 'right'
              })}
            >
              <Typography variant="body" paragraph data-motion-paragraph>
                {paragraph}
              </Typography>
            </div>
          ) : null}
        </Grid>
      </Container>
    </Section>
  )
}

export default SingleParagraph
